import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { withTrackingParams } from "../utils/utmify";
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  type?: "button" | "submit";
  disabled?: boolean;
  variant?: "leaf" | "rose" | "navy" | "olive";
  className?: string;
}
const VARIANTS = {
  leaf: "bg-leaf hover:bg-leaf-dark focus-visible:ring-leaf",
  rose: "bg-rose-600 hover:bg-rose-700 focus-visible:ring-rose-400",
  navy: "bg-navy hover:bg-navy-soft focus-visible:ring-navy-soft",
  olive: "bg-olive-600 hover:bg-olive-700 focus-visible:ring-olive-600"
};
export function PrimaryButton({
  children,
  onClick,
  href,
  type = "button",
  disabled = false,
  variant = "leaf",
  className = ""
}: PrimaryButtonProps) {
  const classes = `group inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-sm transition-[background-color,transform,opacity] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100 sm:text-base ${VARIANTS[variant]} ${className}`;
  const content = <>
      <span data-id="element-249" data-mp="2sp41m1zfgav4">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-250" data-mp="2sqf6k54lzont" />
    </>;
  if (href) {
    return <a href={href} className={classes} onClick={e => {
      e.currentTarget.href = withTrackingParams(e.currentTarget.href || href);
    }} data-id="element-251" data-mp="31npjdux2rluu">
        {content}
      </a>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} className={classes} data-id="element-252" data-mp="1cam3vpy9tyxu">
      {content}
    </button>;
}